import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel'
import useUpdateMRP from '../UpdatePriceValue/index.jsx';
import useUploadPhotoProof from '../UploadPhotoProof/index.jsx';
import { Regex } from '../../../utills.js';

export default function useMRPInputField(
    initial_show_mrp_inventory = false,
    parentProps,
    productData,
    isIPhone,
    parentStyles,
    handleChange,
    handleFocus,
    errors,
    setFieldValue
) {
    const props = parentProps;
    const [show_mrp_inventory, set_show_mrp_inventory] = useState(productData.mrp_status === 'REJECTED' || productData.mrp_status === 'EMPTY_MRP_LIST' || productData.mrp_status === 'IMAGES REQUIRED' || initial_show_mrp_inventory)
    const [mrp_modified, set_mrp_modified] = useState(productData?.mrp_modified  || productData.mrp_status === 'REJECTED' || productData.mrp_status === 'IMAGES REQUIRED')
    const [allowed_mrp_edit, set_allowed_mrp_edit] = useState(false)
    const [initialMrp , setInitialMrp] = useState(productData.mrp?.toString()?.replaceAll(',', '') || "");
    const viaOmni =  useSelector(state=>state.session?.viaOmni)
    const { showMRPModal, getUpdateMRPModal, mrp: mrpValue } = useUpdateMRP(
        (value) => {
            // setFieldValue("mrp", value, productData.uomType);
            handleChange(null,"mrp", {value});
            setInitialMrp(() => value);
            let validated = 0;
            productData?.mrp_list?.forEach((l) => {
                if(Math.round(Number(l)) === Math.round(Number(value))){
                    validated = 1;
                }
            });
            if(!validated){
                setTimeout(() => {
                    setFieldValue('isUnknownMrpValue', true);
                }, 200)
                set_mrp_modified(true);
            }else if(validated && mrp_modified){
                set_mrp_modified(false);
                setFieldValue('isUnknownMrpValue', false);
            }
        },
        productData.mrp?.toString()?.replaceAll(',', '') || "",
        productData,
        false,
        isIPhone
    )
    const { getBothCommentAndUpload } = useUploadPhotoProof(show_mrp_inventory && mrp_modified,(...e)=>{
        console.log("UploadPhotoProof",e,productData.mrp)
        const [mrpProofImages,productFrontImages, cur_batch]=e;
        setFieldValue('uploadImageError', '');
        setFieldValue('uploadProductFrontImageError', '');
        if(mrpProofImages?.length){
            const upload_urls=mrpProofImages.map(uploads=>uploads.url)
            setFieldValue("mrp_images",upload_urls.join(","),productData.uomType)           
        }else{
            setFieldValue('mrp_images','');
        }
        if(productFrontImages?.length){
            const upload_urls=productFrontImages.map(uploads=>uploads.url)
            setFieldValue("mrp_front_img",upload_urls.join(","),productData.uomType)
        }else{
            setFieldValue('mrp_front_img','');
        }
    }, undefined , [productData?.uploadImageError, productData?.uploadProductFrontImageError])

    const handleBlur = (e) => {
        const { target: { value } } = e;
        console.log(value);
        const show_mrp_inv= !(productData.isTempProd && productData?.mrp_list?.some(mrp=>Number(mrp)==Number(value)))
        handleChange(null,"mrp", {value});
        if(!viaOmni) {
            set_mrp_modified(show_mrp_inv);
            set_allowed_mrp_edit(false);
            set_show_mrp_inventory(true);
        }
        setTimeout(() => {
            setFieldValue('isUnknownMrpValue', true);
        },100);
    }

    const handleMrpChange = (e) => {
        const { target:{ value } } = e;
        if(!Regex.priceRegex.test(value)){
            return ;
        }
        setInitialMrp(() => value);
    }

    const MRPdeBounceOnChange={
        timeout:null,
        set callback(cb){
            if(this.timeout!=null){
                clearTimeout(this.timeout)
            }
            this.timeout=setTimeout(cb,4000)
        }
    }  

    const setMRPEditStatus=()=>{
        set_allowed_mrp_edit(productData.mrp?.toString().trim()=="")
    }

    // const [inputEmptyCheck,set_inputEmptyCheck]=useState(false)
    // useEffect(() => {
    //     if(!inputEmptyCheck && productData?.mrp){
    //         setMRPEditStatus()
    //         set_inputEmptyCheck(true)
    //     }
    // }, [productData.mrp])
    

    const getExpiryData=()=>{
        const {
            bestBefore,
            bestBeforeUnit,
            manufacturingDate,            
        }=props.itemInfo
        return {
            bestBefore,
            bestBeforeUnit,
            manufacturingDate,
            expiryBy
        }
    }


    const getMRPInput = (hide = false) => {
        return  {
            hide,
            customJSX: (
                <div className={parentStyles["mrp-input-wrap"]}>
                    <InputWithMovingLabel
                        label={"MRP"}
                        key={"mrp"}
                        holderClass={errors?.['mrp'] ? "" : parentStyles["mrp-input"] + " " + (props.session.isReadOnly ? "read-only-mode" : "")}
                        input={{
                            value: initialMrp,
                            // autoFocus: true,
                            type: isIPhone ? "text" : "tel",
                            onChange: (e) => handleMrpChange(e),
                            // readOnly: props.session.isReadOnly ? true : false,
                            // readOnly:true,
                            disabled: viaOmni ? false :  (show_mrp_inventory && !allowed_mrp_edit)  ,
                            errorMessage: errors?.[`mrp`],
                            className: ` ${errors?.[`mrp`] ? parentStyles["dim-red-border"] : ""}`,
                            onFocus: (e) => handleFocus(e, "mrp"),
                            onBlur: handleBlur
                        }}
                        errorMessage={errors?.[`mrp`]}
                        errClass={`${parentStyles["batch-input-error"]} ${errors[`mrp`] == "allSellFieldEmpty" ? "hide-error-text" : ""
                            }`}
                    />
                    {
                        show_mrp_inventory && !viaOmni &&
                        <div className={parentStyles["bottom-text"]} onClick={e => showMRPModal(true)}>
                            <span class="icon-editItem"></span>
                            <div className={parentStyles["edit-mrp"]}>
                                Edit MRP
                            </div>
                        </div>

                    }
                </div>
            )
        }
    }

    return {
        getMRPInput,
        getUpdateMRPModal,
        getBothCommentAndUpload,
        set_show_mrp_inventory,
        setInitialMrp,
    }

}
